<template>
    <div class="widget">
        <div class="widget-header">
            {{$t('dns.title')}}
        </div>
        <div class="widget-body">
            <div class="d-flex flex-md-row flex-column align-items-center justify-content-md-between">
                <router-link class="btn btn-primary btn-sm dropdown-toggle" type="button" :to="'/domains'">
                    {{$t('dns.add_domain')}}
                </router-link>
            </div>
            <table class="table table-striped first-td-padding">
                <thead>
                    <tr>
                      <td>{{$t('notificationsPage.table.title')}}</td>
                        <td>{{$t('dns.table.options')}}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in domains" :id="key" :key="key">
                        <td>{{ item.domain }}</td>
                        <td>
                            <router-link
                                :to="`/dns/${item.id}`"
                                class="btn btn-primary btn-micro btn-with-icon rounded-icon"
                            >
                                <div class="btn-with-icon-content">
                                    <i class="ion-md-create ion"></i>
                                </div>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { getAxios } from 'services/ajax'
import store from '../../store'

export default {
    data () {
        return {
            domains: []
        }
    },
    mounted () {
      store.commit('setLoading', true)
        getAxios().get('/customer/domains')
            .then(response => {
                this.domains = response.data.domains
            })
            .catch(err => {
                if (err.response) {
                    console.log(err)
                }
            })
            .finally(response => store.commit('setLoading', false))
    },
    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/dns/Domains.vue